// Screen `data-quality` — design/screens/ConflictReview.dc.html — owner: S6. A work queue of the app, not a setting.
import { createFileRoute } from '@tanstack/react-router';
import { DataQualityPage } from '../../features/quality/DataQualityPage';
import { DataQualitySearch } from '../../features/quality/search';

export const Route = createFileRoute('/_app/data-quality')({
  validateSearch: DataQualitySearch,
  component: DataQualityRoute,
});

function DataQualityRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DataQualityPage
      tab={tab ?? 'conflicts'}
      onTab={(next) =>
        void navigate({
          search: (s) => ({ ...s, tab: next === 'conflicts' ? undefined : next }),
          replace: true,
        })
      }
    />
  );
}
